import styled from 'styled-components';

export const NewsCategory = styled.div`
  width: 150px;
  position: absolute;
  bottom: 43px;
  transform: translateY(100%);
`;

export const Title = styled.div`
  width: 130px;
  height: 43px;

  font-size: 18px;
  font-family: PingFangSC;
  font-weight: bold;
  color: rgba(47, 255, 252, 1);
  line-height: 43px;
  text-align: center;
  /* border: 1px solid coral; */

  position: relative;
  z-index: 1;
  > .bg-img-wrapper {
    position: absolute;
    top: -12px;
    bottom: -11px;
    left: -11px;
    right: -12px;
    z-index: -1;
    > .bg-img {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }
  }
`;

export const Content = styled.div`
  padding-top: 16px;
`;

export const Video = styled.div`
  height: 74px;
  line-height: 74px;
  text-align: center;

  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(254, 254, 254, 0.8);

  position: relative;
  z-index: 1;
  cursor: pointer;

  > .bg-img-wrapper {
    position: absolute;
    z-index: -1000;
    top: -68px;
    bottom: -9px;
    left: -11px;
    right: -9px;
    > .bg-img {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      right: 0;
    }
  }

  > .active-img-wrapper {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: -1000;
    width: 164px;
    height: 42px;
    display: none;

    > .active-img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  &.active,
  &:hover {
    > .active-img-wrapper {
      display: block;
    }
  }
`;

export const News = styled.div`
  position: relative;
  padding-top: 27px;
  padding-bottom: 27px;
  > .bg-img-wrapper {
    position: absolute;
    z-index: -1000;
    top: -4px;
    bottom: -4px;
    left: -10px;
    right: -10px;
    > .bg-img {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      right: 0;
    }
  }

  > .news-item {
    cursor: pointer;
    display: block;
    padding-left: 44px;
    box-sizing: border-box;
    height: 42px;

    line-height: 42px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.8);

    position: relative;
    z-index: 1;
    > .active-img-wrapper {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      z-index: -1000;
      width: 164px;
      height: 42px;
      display: none;

      > .active-img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }

    &.active,
    &:hover {
      > .active-img-wrapper {
        display: block;
      }
    }
  }
`;
